

















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import format from 'date-fns/format';

import DownloadButton from '@/components/DownloadButton/DownloadButton.vue';
import ReleaseNoteDownloadButton from '@/components/ReleaseNoteDownloadButton/ReleaseNoteDownloadButton.vue';

@Component({
  components: {
    DownloadButton,
    ReleaseNoteDownloadButton,
  },
  name: 'ReleaseList',
})
export default class ReleaseList extends Vue {
  @Prop() releases!: AppStore.Release[];

  private downloadLoaderOpen = false;

  get reverseReleases(): AppStore.Release[] {
    const list = [...this.releases];
    return list.reverse();
  }

  get groupReleasesByVersion(): {
    version: string;
    latest: AppStore.Release;
    patches: AppStore.Release[];
  }[] {
    const collection = this.reverseReleases;

    const versions = [
      ...new Set(
        collection.map((item) => {
          const match = item.version.match(/[0-9]+\.[0-9]+/gm) as string[];
          return match[0];
        }),
      ),
    ];

    const releaseTree = versions.map((version) => {
      const available = collection.filter((item) => `v${item.version}`.startsWith(`v${version}.`));
      const latest = available[0];
      const patches = available.filter((_item, index) => !!index);

      return { version, latest, patches };
    });

    return releaseTree;
  }

  releaseTime(date: string): string {
    const parsedDate = new Date(date);
    return format(parsedDate, 'MMMM do yyyy');
  }
}
